import { MESSAGES } from 'src/modules/common/constants.ts';
import { useContext } from 'react';
import { ConfigContext } from 'src/configContext.ts';
import { CalcV100 } from 'src/modules/user-input/components/CalcV100.tsx';
import { CalcMaxDP } from 'src/modules/user-input/components/CalcMaxDP.tsx';
import { RegionsEnum } from 'src/generated/operations.ts';
import { AllowedUnits } from 'src/modules/user-input/calcV100/unitsMapping.ts';
import {
    VolumetricFlowCalculatorDataState,
    VolumetricFlowCalculatorInput,
} from 'src/modules/user-input/calcVolumetricFlow/types.ts';
import { targetUnits } from 'src/modules/user-input/targetUnits.ts';
import { Unit } from 'uom';
import { CalcFtHead } from 'src/modules/user-input/components/CalcFtHead.tsx';
import { CalcKindEnum } from 'shared/enums/CalcKindEnum';

export type HandleModalTransferEvent = {
    value: string;
    unit: Unit.Unit<unknown>;
    additionals?: Partial<VolumetricFlowCalculatorInput>;
}

export type ModalState = {
    field: keyof VolumetricFlowCalculatorDataState;
    unit: Unit.Unit<unknown>;
} | null;

type FlowCalculatorModalsProps = {
    allowedUnits: AllowedUnits;
    modalsState: ModalState;
    kind: CalcKindEnum;
    handleModalClose: () => void;
    handleModalTransfer: (detail: HandleModalTransferEvent) => void;
}

export const FlowCalculatorModals = ({
    modalsState,
    kind,
    handleModalClose,
    handleModalTransfer,
    allowedUnits,
}: FlowCalculatorModalsProps) => {
    const config = useContext(ConfigContext);

    return (
        <>
            <CalcV100
                opened={modalsState?.field === 'v100'}
                title={MESSAGES.CalcV100Title}
                titleResult={MESSAGES.CalcV100TitleResult}
                description={MESSAGES.CalcV100TitleDescr}
                allowedUnits={allowedUnits}
                unitSelectionOptions={allowedUnits.volumetricFlow}
                targetUnit={modalsState?.unit || targetUnits.volumetricFlow}
                uuid="v100"
                handleModalClose={handleModalClose}
                handleModalTransfer={handleModalTransfer}
            />
            {/* @TODO implement proper calc */}
            <CalcV100
                opened={modalsState?.field === 'mass'}
                title={MESSAGES.CalcMassFlowTitle}
                titleResult={MESSAGES.CalcMassFlowTitleResult}
                description={MESSAGES.CalcMassFlowTitleDescr}
                allowedUnits={allowedUnits}
                unitSelectionOptions={allowedUnits.massFlow}
                targetUnit={modalsState?.unit || targetUnits.massVolumetricFlow}
                uuid="mass"
                handleModalClose={handleModalClose}
                handleModalTransfer={handleModalTransfer}
            />

            {config.userSettings.currentRegion === RegionsEnum.Am && (
                <CalcFtHead
                    opened={modalsState?.field === 'maxDp'}
                    title={MESSAGES.CalcMaxDPTitle}
                    titleResult={MESSAGES.CalcMaxDPTitleResult}
                    description={MESSAGES.CalcMaxDPTitleDescr}
                    allowedUnits={allowedUnits}
                    targetUnit={modalsState?.unit || targetUnits.dpv100}
                    uuid="maxDp"
                    handleModalClose={handleModalClose}
                    handleModalTransfer={handleModalTransfer}
                />
            )}

            <CalcMaxDP
                opened={modalsState?.field === 'inlet'}
                title={MESSAGES.CalcInletTitle}
                titleResult={MESSAGES.CalcInletTitleResult}
                description={MESSAGES.CalcInletDescr}
                allowedUnits={allowedUnits}
                targetUnit={modalsState?.unit || targetUnits.dpv100}
                kind={kind}
                handleModalClose={handleModalClose}
                handleModalTransfer={handleModalTransfer}
            />

            <CalcMaxDP
                opened={modalsState?.field === 'outlet'}
                title={MESSAGES.CalcOutletTitle}
                titleResult={MESSAGES.CalcOutletTitleResult}
                description={MESSAGES.CalcOutletDescr}
                allowedUnits={allowedUnits}
                targetUnit={modalsState?.unit || targetUnits.dpv100}
                kind={kind}
                handleModalClose={handleModalClose}
                handleModalTransfer={handleModalTransfer}
            />
        </>
    );
};
